<template>
    <f-modal
        :visible="isVisible"
        class="alm-deployment-modal"
        :title="localizer.Localize('LandscapeManagement_Changeset_Deployment_Modal_Header_Text')"
        @update:visible="(vis: boolean) => setVisible(vis)"
    >
        <div class="alm-deployment-modal-body">
            <p class="alm-deployment-modal-subheader" v-html="localizer.FormatParameterizedLocalize('LandscapeManagement_Changeset_Deployment_Modal_Text', [currentChangeset?.name])"/>
            <div class="alm-deployment-modal-details">
                <h4 class="alm-deployment-modal-details-title">{{ localizer.Localize('LandscapeManagement_Objects') }}</h4>
                <p class="alm-deployment-modal-details-text">{{ currentChangeset?.count ? currentChangeset?.count : '' }}</p>
            </div>
            <div class="alm-deployment-modal-details">
                <h4 class="alm-deployment-modal-details-title">{{ localizer.Localize('LandscapeManagement_Changeset_Source') }}</h4>
                <p class="alm-deployment-modal-details-text">{{ currentChangeset?.source ? currentChangeset?.source : '' }}</p>
            </div>
            <div class="alm-deployment-modal-details">
                <h4 class="alm-deployment-modal-details-title">{{ localizer.Localize('LandscapeManagement_Changeset_Target') }}</h4>
                <p class="alm-deployment-modal-details-text">{{ getTargetTenant() }}</p>
            </div>
        </div>
        <template v-slot:footer>
            <div class="flex justify-end">
                <f-button text="Button" type="default" @click="setVisible(false)">
                    {{ localizer.Localize("Cancel_PascalCase") }}
                </f-button>
                <f-button text="Button" type="primary" @click="confirmDeployment">
                    {{ localizer.Localize("LandscapeManagement_Deploy_Text") }}
                </f-button>
            </div>
        </template>
    </f-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { IChangesetDetails } from "./LandscapeManagementInterfaces";

export default defineComponent({
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
    props: {
        isVisible: Boolean,
        currentChangeset: Object,
    },
    methods: {
        setVisible(val: boolean) {
            this.$emit("close", val);
        },
        async confirmDeployment() {
            this.$emit("initiateDeployment");
        },
        getTargetTenant() {
            const changeset = this.currentChangeset;
            if (changeset?.detail && Array.isArray(changeset.detail) && changeset.detail.length > 0) {

                const tenantNames = changeset.detail
                    .map((detail: IChangesetDetails) => {
                        if (detail?.tenant && detail?.include) {
                            return detail.tenant;
                        }
                        return null;
                    })
                    .filter((name: string | null) => name) 
                    .join(', '); 

                return tenantNames || "";
            }
            
            return "";
        },
    },
});
</script>

<style scoped>
.alm-deployment-modal-body {
    padding: 16px;
    gap: 16px;
    display: flex;
    flex-direction: column;
}

.alm-deployment-modal-subheader {
    margin: 0; 
}

.alm-deployment-modal-details {
    display: flex;
    flex-direction: column;
}

.alm-deployment-modal-details-title {
    display: flex;
    font-size: 14px;
    margin: 0;
}

.alm-deployment-modal-details-text {
    font-size: 14px;
    margin: 0;
}
</style>

<style>
.alm-deployment-modal .ant-modal-content {
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.alm-deployment-modal .ant-modal-footer {
    padding: 16px;
    border-top: solid 1px var(--accent-color3);
}

.alm-deployment-modal .ant-modal-body {
    flex-grow: 1;
    overflow-y: auto;
}
</style>
